import {hitAlgolytics} from "@pg-mono/algolytics";

/*
    View event
 */
interface IHitOpenArticlePayload {
    id: number;
    url: string;
}

export const hitOpenArticle = (payload: IHitOpenArticlePayload) => {
    const collectionName = "article_view";

    hitAlgolytics(collectionName, payload);
};

/*
    Events
 */
interface IHitClickOnArticleContentsPayload {
    article_id: number;
}

export const hitClickOnArticleContents = (payload: IHitClickOnArticleContentsPayload) => {
    const collectionName = "article_contents_list";
    const eventData = {
        ...payload,
        event_type: "contents_click"
    };

    hitAlgolytics(collectionName, eventData);
};

interface IHitClickOnArticleLinkPayload {
    article_id: number;
    type: "button" | "href";
    link_url: string;
}

export const hitClickOnArticleLink = (payload: IHitClickOnArticleLinkPayload) => {
    const collectionName = "article_link";
    const eventData = {
        ...payload,
        event_type: "link_click"
    };

    hitAlgolytics(collectionName, eventData);
};

interface IHitClickOnArticleRatingPayload {
    article_id: number;
    type: "top" | "down" | "equal";
}

export const hitClickOnArticleRating = (payload: IHitClickOnArticleRatingPayload) => {
    const collectionName = "article_rating";
    const eventData = {
        ...payload,
        event_type: "rating_click"
    };

    hitAlgolytics(collectionName, eventData);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

/*
    View event
 */
interface IHitOpenArticlePayload {
    id: number;
    url: string;
}

export const hitOpenArticle = (payload: IHitOpenArticlePayload) => {
    const collectionName = "article_view";

    hitAlgolytics(collectionName, payload);
};

/*
    Events
 */
interface IHitClickOnArticleContentsPayload {
    article_id: number;
}

export const hitClickOnArticleContents = (payload: IHitClickOnArticleContentsPayload) => {
    const collectionName = "article_contents_list";
    const eventData = {
        ...payload,
        event_type: "contents_click"
    };

    hitAlgolytics(collectionName, eventData);
};

interface IHitClickOnArticleLinkPayload {
    article_id: number;
    type: "button" | "href";
    link_url: string;
}

export const hitClickOnArticleLink = (payload: IHitClickOnArticleLinkPayload) => {
    const collectionName = "article_link";
    const eventData = {
        ...payload,
        event_type: "link_click"
    };

    hitAlgolytics(collectionName, eventData);
};

interface IHitClickOnArticleRatingPayload {
    article_id: number;
    type: "top" | "down" | "equal";
}

export const hitClickOnArticleRating = (payload: IHitClickOnArticleRatingPayload) => {
    const collectionName = "article_rating";
    const eventData = {
        ...payload,
        event_type: "rating_click"
    };

    hitAlgolytics(collectionName, eventData);
};
